(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saunaplunge-installation-addon"] && !Shopify.designMode) return;
  try {
    class SaunaPlungeInstallationAddon extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.saunaplunge-installation-addon__checkbox');
      this.form = document.getElementById(this.getAttribute('form-id'));

      if (!this.checkbox || !this.form) {
        return;
      }

      this.sync = this.sync.bind(this);
      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.checkbox.addEventListener('change', this.handleCheckboxChange);
      this.form.addEventListener('change', this.sync);
      this.form.addEventListener('input', this.sync);
      this.form.addEventListener('submit', this.handleSubmit, { capture: true });
      this.sync();
    }

    disconnectedCallback() {
      if (!this.checkbox || !this.form) {
        return;
      }

      this.checkbox.removeEventListener('change', this.handleCheckboxChange);
      this.form.removeEventListener('change', this.sync);
      this.form.removeEventListener('input', this.sync);
      this.form.removeEventListener('submit', this.handleSubmit, { capture: true });
    }

    handleCheckboxChange(event) {
      event.stopPropagation();
      this.sync();
    }

    async handleSubmit(event) {
      if (!this.checkbox.checked) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (event.submitter?.getAttribute('aria-busy') === 'true') {
        return;
      }

      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      const formData = new FormData(this.form);
      const mainVariantId = Number.parseInt(formData.get('id'), 10);
      const installationVariantId = Number.parseInt(this.getAttribute('installation-variant-id'), 10);
      const quantity = Math.max(1, Number.parseInt(formData.get('quantity') || '1', 10) || 1);

      if (!mainVariantId || !installationVariantId) {
        return;
      }

      const mainItem = { id: mainVariantId, quantity };
      const properties = {};

      for (const [name, value] of formData.entries()) {
        const propertyMatch = name.match(/^properties\[(.*)\]$/);

        if (propertyMatch && typeof value === 'string' && value !== '') {
          properties[propertyMatch[1]] = value;
        }
      }

      if (Object.keys(properties).length > 0) {
        mainItem.properties = properties;
      }

      const sellingPlan = formData.get('selling_plan');

      if (sellingPlan) {
        mainItem.selling_plan = Number.parseInt(sellingPlan, 10) || sellingPlan;
      }

      const submitButtons = Array.from(this.form.elements).filter((element) => element.type === 'submit');
      submitButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              mainItem,
              {
                id: installationVariantId,
                quantity,
                parent_id: mainVariantId,
              },
            ],
            sections: sectionsToBundle.join(','),
            sections_url: `${Shopify.routes.root}variants/${mainVariantId}`,
          }),
        });
        const responseJson = await response.json();

        if (!response.ok) {
          throw new Error(responseJson.description || responseJson.message || 'Unable to add the items to the cart.');
        }

        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;
        const onSuccessDo = formData.get('on_success');

        this.form.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [],
              cart: cartContent,
              onSuccessDo,
            },
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              onSuccessDo,
              cart: cartContent,
            },
          })
        );
      } catch (error) {
        this.form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: error.message },
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } finally {
        submitButtons.forEach((button) => button.removeAttribute('aria-busy'));
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    sync() {
      const enabled = this.checkbox.checked;
      this.toggleAttribute('data-selected', enabled);
    }
  }

  if (!customElements.get('saunaplunge-installation-addon')) {
    customElements.define('saunaplunge-installation-addon', SaunaPlungeInstallationAddon);
  }
  } catch(e) { console.error(e); }
})();

})();
